import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FileText, Shield, AlertCircle } from 'lucide-react';
export const TermsPage = () => {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-1932">
      <Header data-id="element-1933" />

      <main id="main-content" className="flex-grow py-12" role="main" data-id="element-1934">
        <div className="container" data-id="element-1935">
          <div className="max-w-4xl mx-auto" data-id="element-1936">
            {/* Header */}
            <div className="text-center mb-12" data-id="element-1937">
              <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-1938">
                <FileText size={32} className="text-primary-600" data-id="element-1939" />
              </div>
              <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1940">
                Terms of Service
              </h1>
              <p className="text-lg text-gray-600" data-id="element-1941">
                Last Updated: January 15, 2025
              </p>
            </div>

            {/* Content */}
            <div className="prose prose-lg max-w-none" data-id="element-1942">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-8 rounded-r-lg" data-id="element-1943">
                <div className="flex items-start gap-4" data-id="element-1944">
                  <AlertCircle size={24} className="text-blue-600 flex-shrink-0 mt-1" data-id="element-1945" />
                  <div data-id="element-1946">
                    <p className="font-semibold text-blue-900 mb-2" data-id="element-1947">
                      Important Notice
                    </p>
                    <p className="text-blue-800 text-sm" data-id="element-1948">
                      By accessing and using Geldhaus Africa's services, you
                      agree to be bound by these Terms of Service. Please read
                      them carefully before applying for any loan products.
                    </p>
                  </div>
                </div>
              </div>

              <section className="mb-8" data-id="element-1949">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1950">
                  1. Acceptance of Terms
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1951">
                  These Terms of Service ("Terms") govern your use of Geldhaus
                  Africa's website, mobile applications, and financial services.
                  By accessing our platform or applying for a loan, you
                  acknowledge that you have read, understood, and agree to be
                  bound by these Terms.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-1952">
                  If you do not agree with any part of these Terms, you must not
                  use our services.
                </p>
              </section>

              <section className="mb-8" data-id="element-1953">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1954">
                  2. Eligibility
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1955">
                  To use Geldhaus Africa's services, you must:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-1956">
                  <li data-id="element-1957">Be at least 18 years of age</li>
                  <li data-id="element-1958">Be a Kenyan citizen or legal resident</li>
                  <li data-id="element-1959">Have a valid National ID or Passport</li>
                  <li data-id="element-1960">
                    Have a registered business or verifiable source of income
                  </li>
                  <li data-id="element-1961">
                    Provide accurate and complete information during the
                    application process
                  </li>
                  <li data-id="element-1962">
                    Not be in default on any existing loans with Geldhaus or
                    other financial institutions
                  </li>
                </ul>
              </section>

              <section className="mb-8" data-id="element-1963">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1964">
                  3. Loan Products & Services
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1965">
                  Geldhaus Africa offers the following loan products:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-1966">
                  <li data-id="element-1967">
                    <strong data-id="element-1968">Fast Cash Logbook Loans:</strong> KSh 100,000 -
                    3,000,000
                  </li>
                  <li data-id="element-1969">
                    <strong data-id="element-1970">Secured Business Loans:</strong> KSh 500,000 -
                    5,000,000
                  </li>
                  <li data-id="element-1971">
                    <strong data-id="element-1972">Car & Asset Financing:</strong> KSh 500,000 -
                    10,000,000
                  </li>
                  <li data-id="element-1973">
                    <strong data-id="element-1974">Trade Finance Solutions:</strong> Customized amounts
                  </li>
                </ul>
                <p className="text-gray-700 leading-relaxed" data-id="element-1975">
                  All loan products are subject to approval based on
                  creditworthiness, collateral value, and other factors
                  determined by Geldhaus Africa.
                </p>
              </section>

              <section className="mb-8" data-id="element-1976">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1977">
                  4. Interest Rates & Fees
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1978">
                  Interest rates vary by product and are disclosed during the
                  application process:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-1979">
                  <li data-id="element-1980">Logbook Loans: From 3.5% per month</li>
                  <li data-id="element-1981">Business Loans: From 2.5% per month</li>
                  <li data-id="element-1982">Asset Financing: From 12% per annum</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1983">
                  Additional fees may include:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-1984">
                  <li data-id="element-1985">Processing fee: 2-5% of loan amount</li>
                  <li data-id="element-1986">Late payment penalty: 1% per day on overdue amount</li>
                  <li data-id="element-1987">
                    Valuation fee (for asset-backed loans): KSh 2,000 - 5,000
                  </li>
                </ul>
              </section>

              <section className="mb-8" data-id="element-1988">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1989">
                  5. Repayment Terms
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1990">
                  Borrowers agree to repay loans according to the agreed
                  schedule. Payment methods include:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-1991">
                  <li data-id="element-1992">M-Pesa</li>
                  <li data-id="element-1993">Bank transfer</li>
                  <li data-id="element-1994">Direct debit</li>
                  <li data-id="element-1995">Cash deposit at our offices</li>
                </ul>
                <p className="text-gray-700 leading-relaxed" data-id="element-1996">
                  Failure to make timely payments may result in late fees,
                  negative credit reporting, and potential legal action.
                </p>
              </section>

              <section className="mb-8" data-id="element-1997">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1998">
                  6. Collateral & Security
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1999">
                  For secured loans, borrowers must provide collateral (e.g.,
                  vehicle logbook, property title). Geldhaus Africa reserves the
                  right to:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-2000">
                  <li data-id="element-2001">
                    Hold the original logbook/title until full loan repayment
                  </li>
                  <li data-id="element-2002">Conduct periodic inspections of collateral</li>
                  <li data-id="element-2003">Repossess collateral in case of default</li>
                  <li data-id="element-2004">Sell collateral to recover outstanding debt</li>
                </ul>
              </section>

              <section className="mb-8" data-id="element-2005">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2006">
                  7. Default & Collections
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2007">
                  A loan is considered in default if:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-2008">
                  <li data-id="element-2009">Payment is more than 30 days overdue</li>
                  <li data-id="element-2010">Borrower provides false information</li>
                  <li data-id="element-2011">
                    Collateral is damaged, sold, or transferred without consent
                  </li>
                </ul>
                <p className="text-gray-700 leading-relaxed" data-id="element-2012">
                  In case of default, Geldhaus Africa may pursue legal action,
                  report to credit bureaus, and engage collection agencies.
                </p>
              </section>

              <section className="mb-8" data-id="element-2013">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2014">
                  8. Privacy & Data Protection
                </h2>
                <p className="text-gray-700 leading-relaxed" data-id="element-2015">
                  Your personal information is protected under our{' '}
                  <a href="/legal/privacy" className="text-primary-600 hover:underline font-semibold" data-id="element-2016">
                    Privacy Policy
                  </a>
                  . We comply with Kenya's Data Protection Act, 2019.
                </p>
              </section>

              <section className="mb-8" data-id="element-2017">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2018">
                  9. Regulatory Compliance
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2019">
                  Geldhaus Africa is a licensed non-deposit taking credit
                  provider regulated by the Central Bank of Kenya (CBK). We
                  comply with:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-2020">
                  <li data-id="element-2021">Central Bank of Kenya Act</li>
                  <li data-id="element-2022">Microfinance Act, 2006</li>
                  <li data-id="element-2023">Data Protection Act, 2019</li>
                  <li data-id="element-2024">Consumer Protection Act, 2012</li>
                </ul>
              </section>

              <section className="mb-8" data-id="element-2025">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2026">
                  10. Limitation of Liability
                </h2>
                <p className="text-gray-700 leading-relaxed" data-id="element-2027">
                  Geldhaus Africa is not liable for indirect, incidental, or
                  consequential damages arising from the use of our services.
                  Our total liability is limited to the amount of fees paid by
                  you.
                </p>
              </section>

              <section className="mb-8" data-id="element-2028">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2029">
                  11. Amendments
                </h2>
                <p className="text-gray-700 leading-relaxed" data-id="element-2030">
                  We reserve the right to modify these Terms at any time.
                  Changes will be posted on this page with an updated "Last
                  Modified" date. Continued use of our services constitutes
                  acceptance of the revised Terms.
                </p>
              </section>

              <section className="mb-8" data-id="element-2031">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2032">
                  12. Governing Law
                </h2>
                <p className="text-gray-700 leading-relaxed" data-id="element-2033">
                  These Terms are governed by the laws of the Republic of Kenya.
                  Any disputes shall be resolved in Kenyan courts.
                </p>
              </section>

              <section className="mb-8" data-id="element-2034">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2035">
                  13. Contact Information
                </h2>
                <div className="bg-gray-50 rounded-xl p-6" data-id="element-2036">
                  <p className="text-gray-700 mb-4" data-id="element-2037">
                    For questions about these Terms, please contact us:
                  </p>
                  <ul className="space-y-2 text-gray-700" data-id="element-2038">
                    <li data-id="element-2039">
                      <strong data-id="element-2040">Email:</strong> legal@geldhaus.africa
                    </li>
                    <li data-id="element-2041">
                      <strong data-id="element-2042">Phone:</strong> +254 100 254 254
                    </li>
                    <li data-id="element-2043">
                      <strong data-id="element-2044">Address:</strong> Nairobi, Kenya
                    </li>
                    <li data-id="element-2045">
                      <strong data-id="element-2046">Business Hours:</strong> Monday - Friday, 8:00 AM
                      - 5:00 PM EAT
                    </li>
                  </ul>
                </div>
              </section>

              <div className="bg-primary-50 border-l-4 border-primary-600 p-6 rounded-r-lg mt-8" data-id="element-2047">
                <div className="flex items-start gap-4" data-id="element-2048">
                  <Shield size={24} className="text-primary-600 flex-shrink-0 mt-1" data-id="element-2049" />
                  <div data-id="element-2050">
                    <p className="font-semibold text-primary-900 mb-2" data-id="element-2051">
                      Your Rights
                    </p>
                    <p className="text-primary-800 text-sm" data-id="element-2052">
                      As a borrower, you have the right to transparent pricing,
                      fair treatment, and access to your loan information. If
                      you believe your rights have been violated, please contact
                      our compliance team immediately.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2053" />
    </div>;
};